import React from "react";
import { graphColors } from "utils/styles";
import { Pie, PieChart, Tooltip, ResponsiveContainer } from "recharts";

const OUTCOME_LABELS = {
  ORDERED_SUPPLIES: "Ordered Supplies",
  DECLINED_SUPPLIES: "Declined Supplies",
  REQUESTED_CALL_BACK: "Requested Callback",
  LEFT_CALL_BACK_NUMBER: "Left Callback Number",
  TRANSFERRED: "Transferred to S3",
  OTHER: "Other"
};

// Format unknown keys to Title Case (e.g., "SOME_VALUE" -> "Some Value")
const formatLabel = (key) => {
  if (OUTCOME_LABELS[key]) return OUTCOME_LABELS[key];
  return key
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, c => c.toUpperCase());
};

const OutcomeChart = ({ outcomeBreakdown }) => {
  if (!outcomeBreakdown || Object.keys(outcomeBreakdown).length === 0) {
    return (
      <div className="graph-container">
        <h4 className="graph-header">Agent Outcomes</h4>
        <div style={{ textAlign: "center", padding: "40px", color: "#888" }}>
          No outcome data available
        </div>
      </div>
    );
  }

  const data = Object.entries(outcomeBreakdown).map(([key, value], i) => ({
    label: formatLabel(key),
    value,
    fill: graphColors[i % graphColors.length]
  }));

  return (
    <div className="graph-container">
      <h4 className="graph-header">Agent Outcomes</h4>
      <ResponsiveContainer height={250}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="label"
            isAnimationActive={false}
          />
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
      <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "10px", marginTop: "10px" }}>
        {data.map((item, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <div style={{ width: "12px", height: "12px", backgroundColor: item.fill, borderRadius: "2px" }} />
            <span style={{ fontSize: "12px" }}>{item.label}: {item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OutcomeChart;
